import { strings } from '../../localization';

export default class NotificationService {

    constructor(ravens) {

        try {
            if (Notification.permission !== "granted")
                Notification.requestPermission();
        } catch (e) {
            console.warn("Desktop notifications not available in this browser", e);
        }

        this.ravens = ravens;

        // if (BuildSettings.isDev()) {
        //     console.log('TEST NOTIFICATIONS');

        //     document.addEventListener('keydown', (e) => {
        //         this.makeNotification({
        //             detail: {
        //                 event: {
        //                     type: e.key,
        //                 },
        //                 ravenUuid: this.ravens[0].ravenUuid
        //             }
        //         });
        //     })
        // }
    }

    makeNotification(e) {

        if (!e.detail || !e.detail.event) return;
        try {
            console.log('NOTIFICATION: ', e);
            if (!Notification) return;
            if (Notification.permission !== "granted") {
                Notification.requestPermission().then(result => {
                    if(result === 'granted') {
                        this.sendNotification(e);
                    }
                });
            } else {
                this.sendNotification(e);
            }
        } catch (e) {
            console.error('failed to send notification', e);
        }
    }

    sendNotification = (e) => {

        if(!e) return;
        var title = document.getEventName(e.detail.event);
        var messageBody = strings.formatString(strings.event_from_raven, "Raven");
        try {
            let ravenName = this.ravens.find(raven => {
                return raven.ravenUuid === e.detail.ravenUuid;
            }).vehicle.name;
            messageBody = strings.formatString(strings.event_from_raven, ravenName);
        } catch (e) {/*fail to get name silently*/ }

        new Notification(title, {
            body: messageBody,
            icon: 'images/icon-raven-blue.png'
        });
    }
}
